import { useEffect, useState } from 'react';
import { SYNC_EVENT } from './connectionPoll';

export function useConnectionSyncStatus() {
    const [status, setStatus] = useState(
        () => localStorage.getItem('userConnectionSyncStatus') || ''
    );

    useEffect(() => {
        const handler = (e) => {
            const next = e.detail?.status || localStorage.getItem('userConnectionSyncStatus') || '';
            setStatus(next);
        };
        window.addEventListener(SYNC_EVENT, handler);
        return () => window.removeEventListener(SYNC_EVENT, handler);
    }, []);

    return status;
}
